import React, { useRef, useState, useEffect } from "react";
// import axios from "axios";
// import config from "../../config";
import useAxios from "../../utils/useAxios"; // Import the custom Axios instance
import * as tus from "tus-js-client";
import { Link } from "react-router-dom";

const Ads = () => {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0); // Track progress
  const [isUploading, setIsUploading] = useState(false); // Track if upload is ongoing
  const [formData, setFormData] = useState({
    // Ad details
    ad_name: "",
    ad_url: "",
    media: null,
    media_url: "",
  });
  const axiosAPI = useAxios(); // Use the custom hook for Axios

  const resetForm = () => {
    setFormData({
      id: "",
      ad_name: "",
      ad_url: "",
      media_url: "",
    });
  };

  // Function to handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
    console.log({ formData });
  };

  // Handle file selection
  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      const selectedFile = files[0];
      // Update formData with the selected file
      setFormData({ ...formData, media: selectedFile });
      console.log({ formData });
    }
  };

  // Function to fetch ads data from the API
  const fetchEventAds = async () => {
    try {
      const response = await axiosAPI.get(`/api/ads/get-event-ads`);
      const adsData = response.data;

      setAds(adsData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching ads:", error);
      setLoading(false);
    }
  };

  // Fetch ads when component mounts
  useEffect(() => {
    fetchEventAds();
  }, []);

  // New function to upload large video file
  const uploadLargeVideo = async (videoId, presigned_signature) => {
    const library_id = "366380";
    const expiration_time = Math.floor(new Date().getTime() / 1000) + 200000;

    const file = formData.media; // Access the file selected for upload

    // Set upload state to true when upload starts
    setIsUploading(true);

    const videoFileUpload = new tus.Upload(file, {
      endpoint: "https://video.bunnycdn.com/tusupload",
      retryDelays: [0, 3000, 5000, 10000, 20000, 60000, 60000],
      headers: {
        AuthorizationSignature: presigned_signature,
        AuthorizationExpire: expiration_time,
        VideoId: videoId,
        LibraryId: library_id,
      },
      metadata: {
        filetype: file.type,
      },
      onError: function (error) {
        console.error("Failed because: " + error);
        setIsUploading(false); // Reset upload state on error
      },
      onProgress: function (bytesUploaded, bytesTotal) {
        const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
        setUploadProgress(percentage); // Update progress
        // document.getElementById("add_video_progressbar_id").style.width = `${percentage}%`;
        // document.getElementById("add_video_progressbar_id").innerHTML = `${percentage}%`;
        // Update progress bar here with React state or refs
        console.log(bytesUploaded, bytesTotal, percentage + "%");
      },
      onSuccess: function () {
        console.log("Upload success: " + videoFileUpload.url);
        setIsUploading(false); // Reset upload state on error
        // Video upload is complete, now proceed with submitting the form
        handleSubmitAfterUpload(videoId, "video");
        // You can handle success actions here, like updating the UI or notifying the user
      },
    });

    videoFileUpload.findPreviousUploads().then(function (previousUploads) {
      if (previousUploads.length) {
        videoFileUpload.resumeFromPreviousUpload(previousUploads[0]);
      }

      videoFileUpload.start();
    });
  };

  const handleSubmitAfterUpload = async (videoId, media_type) => {
    const formToSubmit = new FormData();
    formToSubmit.append("ad_name", formData.ad_name);
    formToSubmit.append("ad_url", formData.ad_url);

    if (media_type) {
      formToSubmit.append("media_type", media_type);
      if (media_type == "video") {
        formToSubmit.append("video_id", videoId);
      } else {
        formToSubmit.append("media", formData.media); // Add media file (image/video)
      }
    }

    try {
      // Check if it's an existing event (editing)
      const requestUrl = formData.id
        ? `/api/ads/update-event-ad/${formData.id}` // Edit existing event
        : `/api/ads/add-event-ad`; // Add new event

      // Set the correct HTTP method (POST for adding, PUT for editing)
      const httpMethod = formData.id ? "PUT" : "POST";

      // Make the API call to add or edit the event
      const response = await axiosAPI({
        method: httpMethod,
        url: requestUrl,
        data: formToSubmit,
        headers: {
          "Content-Type": "multipart/form-data", // Set the correct content type for file uploads
        },
      });

      window.notifyMessage("Success", "Ad added successfully", "success");
      setIsSubmitting(false);
      resetForm();
      hideModal("newAdModal");
      // Reload the events data (optional, depending on your app)
      fetchEventAds();
    } catch (error) {
      // Check if it's an error from the API response
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage(
          "Error",
          error.response.data.message, // Display specific error message from backend
          "danger"
        );
        setIsSubmitting(false);
      } else {
        // Handle generic errors (e.g., network errors)
        window.notifyMessage("Error", "There was an error!", "danger");
        setIsSubmitting(false);
      }
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    // Validate required fields
    if (!formData.ad_name) {
      window.notifyMessage(
        "Error",
        "Ad Name is mandatory! Please fill the field.",
        "danger"
      );
      setIsSubmitting(false);
      return; // Prevent form submission if any field is missing
    }

    // Validate required fields
    if (!formData.id && !formData.media) {
      window.notifyMessage(
        "Error",
        "Ad media is mandatory! Please fill the field.",
        "danger"
      );
      setIsSubmitting(false);
      return; // Prevent form submission if any field is missing
    }

    if (!formData.media) {
      handleSubmitAfterUpload(null, null);
    } else {
      // If the media is a video, fetch the video ID
      let videoId = null;
      let presigned_signature = null;
      let media_type = "image";
      if (formData.media.type.startsWith("video/")) {
        // FOR now block video
        window.notifyMessage("Error", "Video Not Allowed", "danger");
        setIsSubmitting(false);
        return; // Prevent form submission if any field is missing

        media_type = "video";
        try {
          const videoResponse = await axiosAPI.get(`/api/ads/get-video-id/`);

          videoId = videoResponse.data.video_id; // Get the video ID from the response
          presigned_signature = videoResponse.data.presigned_signature; // Get the video ID from the response

          // After getting the video ID, proceed with the large video upload
          await uploadLargeVideo(videoId, presigned_signature);
        } catch (error) {
          window.notifyMessage(
            "Error",
            "Failed to fetch video ID. Please try again.",
            "danger"
          );
          setIsSubmitting(false);
          return; // Stop submission if there is an error fetching the video ID
        }
      } else {
        // If it's not a video, proceed directly to submit the form
        handleSubmitAfterUpload(null, "image");
      }
    }
  };

  const openAddModal = () => {
    // reset form
    resetForm();
    // Optionally, you can open the modal programmatically here if you're using Bootstrap modals
    showModal("newAdModal");
  };

  const openEditModal = (adId) => {
    const adToEdit = ads.find((ad) => ad.id === adId);

    if (adToEdit) {
      // Set formData with the details of the selected ad
      setFormData({
        id: adToEdit.id, // Set the ad ID
        ad_name: adToEdit.ad_name || "", // Set the ad name
        ad_url: adToEdit.ad_url || "", // Set the ad location
        media_url: adToEdit.media_url || "", // Set custom logo (could be null)
      });

      // Optionally, you can open the modal programmatically here if you're using Bootstrap modals
      showModal("newAdModal");
    }
  };

  const handleDelete = async (adId) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      await axiosAPI.delete(`/api/ads/delete-event-ad/${adId}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchEventAds();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  function showModal(id) {
    const modal_el = document.querySelector("#" + id);
    let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      modal_obj = new window.bootstrap.Modal(modal_el, {
        backdrop: "static",
      });
    }

    modal_obj.show();
  }

  function hideModal(id) {
    const modal_el = document.querySelector("#" + id);
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);

    if (modal_obj == null) {
      return;
    }

    modal_obj.hide();
  }

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div className="d-flex"></div>
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddModal()}
            >
              Add New Ad
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newAdModal"
          tabIndex="-1"
          aria-labelledby="newAdModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title" id="newAdModalLabel">
                  {formData.id ? "Edit Ad" : "Add New Ad"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body bg-light">
                <form onSubmit={handleSubmit}>
                  <div className="card">
                    <div className="card-body">
                      <div className="row mt-3">
                        {/* Ad Name */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="ad_name" className="form-label">
                            Ad Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="ad_name"
                            value={formData.ad_name}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        {/* Ad Location */}
                        <div className="col-md-6 mb-3">
                          <label htmlFor="ad_url" className="form-label">
                            Ad URL
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="ad_url"
                            value={formData.ad_url}
                            onChange={handleChange}
                          />
                        </div>

                        {/* Custom Logo File Upload */}
                        <div className="col-md-12 mb-3">
                          <label htmlFor="media" className="form-label">
                            Photo
                            {formData.media_url ? (
                              <Link
                                to={formData.media_url}
                                target="_blank"
                                className="logo ms-2"
                              >
                                <button
                                  type="button"
                                  className="btn btn-icon btn-dark btn-sm me-2"
                                >
                                  <i className="fas fa-images"></i>
                                </button>
                              </Link>
                            ) : (
                              ""
                            )}
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            id="media"
                            accept="image/*"
                            onChange={handleFileChange}
                          />
                        </div>

                        {/* Progress Bar */}
                        <div
                          className={`col-md-12 mb-3 ${
                            isUploading ? "" : "d-none"
                          }`}
                        >
                          <div className="progress">
                            <div
                              className="progress-bar"
                              id="add_video_progressbar_id"
                              role="progressbar"
                              style={{ width: `${uploadProgress}%` }}
                              aria-valuemin="0"
                              aria-valuemax="100"
                            >
                              {uploadProgress}%
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-success"
                    disabled={isSubmitting} // Disable the button while submitting
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    ) : (
                      "Add Ad"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <div className="d-flex justify-content-between">
                  <div>
                    <h4 className="card-title">
                      All Ads (<span>{ads.length}</span>)
                    </h4>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="display table table-striped table-hover basic-datatables">
                    <thead>
                      <tr>
                        <th>Ad Name</th>
                        <th>Quick Look</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="5" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : (
                        ads.map((ad) => {
                          // Format the ad_date field
                          const formattedAdDate = new Date(
                            ad.ad_date
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          });

                          return (
                            <tr key={ad.id}>
                              <td>{ad.ad_name}</td>
                              <td>
                                {ad.ad_url ? (
                                  <Link
                                    to={ad.ad_url}
                                    target="_blank"
                                    className="logo"
                                  >
                                    <button className="btn btn-icon btn-round btn-dark btn-sm me-2">
                                      <i className="fas fa-link"></i>
                                    </button>
                                  </Link>
                                ) : (
                                  ""
                                )}

                                {ad.media_url ? (
                                  <Link
                                    to={ad.media_url}
                                    target="_blank"
                                    className="logo"
                                  >
                                    <button className="btn btn-icon btn-round btn-dark btn-sm me-2">
                                      <i className="fas fa-images"></i>
                                    </button>
                                  </Link>
                                ) : (
                                  ""
                                )}
                              </td>
                              <td>
                                <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(ad.id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() => handleDelete(ad.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ads;
